import { type DomainAccessControlConfig } from 'domains/insights-portal/utils/domain/accessControl'
import { Flipper } from 'domains/insights-portal/access-control/flippers'

export const insightsPortalInventoryIntelligenceAccessControl: DomainAccessControlConfig = {
  flippers: [Flipper.InsightsPortalInventoryIntelligence],
}
